import { render, staticRenderFns } from "./LegacySearchResult.vue?vue&type=template&id=2dec9460&scoped=true"
import script from "./LegacySearchResult.vue?vue&type=script&lang=js"
export * from "./LegacySearchResult.vue?vue&type=script&lang=js"
import style0 from "./LegacySearchResult.vue?vue&type=style&index=0&id=2dec9460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec9460",
  null
  
)

export default component.exports